/**
 * DetailHeroActionsContainer component.
 */
import styled from 'styled-components';

/**
 * Container for the detail hero actions.
 */
const DetailHeroActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default DetailHeroActionsContainer;
